import { CommentDto, CommentsBodyDto } from '@app/data/dtos/comment/comment-dto';
import { CommentStatus } from '@app/entities/enums/comment/comment.enum';
import { Comment } from '@app/entities/models/comment.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapComment: MapFromFn<CommentDto, Comment> = (value) =>
  Builder.forModel(Comment)
    .id(value.id)
    .user_id(value.user_id)
    .name(value.name)
    .lastname(value.lastname)
    .department(value.department)
    .creation_date(value.creation_date)
    .comment(value.comment)
    .response_comments(value.response_comments?.map(mapComment))
    .status(value.status as CommentStatus)
    .photo(value.photo)
    .cod_store(value.cod_store)
    .store(value.store)
    .language(value.language)
    .division_zone(value.division_zone)
    .role(value.role)
    .show_info(value.show_info)
    .parent_id(value.parent_id || 0)
    .highlighted(value.highlighted)
    .translationKey(value.translation_key)
    .build();

export const mapCommentBody: MapFromFn<CommentsBodyDto, Comment[]> = (value) => value.body.map(mapComment);
